import { renderRating } from '@global/Blocks/SitewideTestimonials/Testimonial'
import * as S from './Raiting.styled'

const Raiting = ({ rating, numberOfReviews, isVertical, officeSidebar }) => {
  const displayRating = Number.isInteger(parseFloat(rating)) ? `${rating}.0` : rating

  return rating && rating >= 4 && numberOfReviews > 0 ? (
    <S.Rating isVertical={isVertical} officeSidebar={officeSidebar}>
      <div>
        {renderRating(rating)} <S.RatingNumber>{displayRating}</S.RatingNumber>
      </div>
      {numberOfReviews && (
        <S.NumberOfReviews>
          ({numberOfReviews} reviews, realestate.com.au)
        </S.NumberOfReviews>
      )}
    </S.Rating>
  ) : null
}

export default Raiting
